export { default } from './BlogList';
